import { Grid } from 'semantic-ui-react';
import { useStore } from '../store/useStore';
import FormField from './FormField';
import CurrencyField from './CurrencyField';
import PercentField from './PercentField';
import DisplayField from './DisplayField';
import withState from './WithState';
import selectors from '../store/selectors';

const SellerForm = (props: any) => {
	const store: any = useStore((state: any) => state);

	return (
		<Grid>
			<Grid.Column>
				<FormField
					labelText={'First Name'}
					placeholder={'Sam'}
					onChange={(input: any) => store.setFirstName(input.target.value)}
					value={props.firstName}
				/>
				<FormField
					labelText={'Last Name'}
					placeholder={'Smith'}
					onChange={(input: any) => store.setLastName(input.target.value)}
					value={props.lastName}
				/>
				<FormField
					labelText={'Email'}
					placeholder={'sam.smith@email.com'}
					onChange={(input: any) => store.setEmail(input.target.value)}
					value={props.email}
				/>
				<FormField
					labelText={'Home Address'}
					placeholder={'1120 Somewhere Ln, Yakima, WA 98908'}
					onChange={(input: any) => store.setHomeAddress(input.target.value)}
					value={props.address}
				/>
				<div className={'kootenai-type-SECTION'}>
					<h3>Seller Information</h3>
				</div>

				<FormField
					labelText={'Sales Price'}
					Component={
						<CurrencyField
							onChange={(_: any, input: any) => {
								store.setSalesPrice(input);
								store.setEscrowFee();
								store.setEstimatedTotalCosts();
								store.setEstimatedNetProceeds();
							}}
							value={store.salesPrice.formatted}
						/>
					}
				/>
				<FormField
					labelText={'Loan Payoff'}
					Component={
						<CurrencyField
							onChange={(event: any, input: any) => {
								store.setLoanPayoffs(input);
								store.setReconveyanceFee();
								store.setEstimatedTotalCosts();
								store.setEstimatedNetProceeds();
							}}
							value={store.loanPayoffs.formatted}
						/>
					}
				/>
				{props.loanPayoffs.raw > 0 && (
					<FormField
						labelText={'Reconveyance fee'}
						Component={
							<CurrencyField
								onChange={() => {
									store.setReconveyanceFee();
									store.setEstimatedTotalCosts();
									store.setEstimatedNetProceeds();
								}}
								value={store.reconveyanceFee}
							/>
						}
					/>
				)}
				<Grid>
					<Grid.Row columns={2}>
						<Grid.Column>
							<FormField
								labelText={'Real Estate Commission'}
								Component={
									<PercentField
										onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
											store.setRealEstateCommissionByPercent(e.target.value);
										}}
										setData={store.setRealEstateCommissionPercent}
										value={store.realEstateCommissionPercent}
									/>
								}
							/>
						</Grid.Column>
						<Grid.Column>
							<FormField
								Component={
									<CurrencyField
										label={'$'}
										onChange={(_: any, input: any) => {
											store.setRealEstateCommissionByAmount(input);
										}}
										value={store.realEstateCommission.formatted}
									/>
								}
							/>
						</Grid.Column>
					</Grid.Row>
				</Grid>
				<div className={'kootenai-type-SECTION'}>
					<h3>Title Insurance</h3>
				</div>

				<FormField
					labelText={`Title Insurance(Owner's policy)`}
					Component={
						<DisplayField
							label={'$'}
							disabled
							value={store.titleInsurance.formatted}
						/>
					}
				/>
				<div className={'kootenai-type-SECTION'}>
					<h3>Escrow Services</h3>
				</div>
				<FormField
					labelText={'Escrow fee'}
					Component={
						<DisplayField
							label={'$'}
							disabled
							value={store.escrowFee.formatted}
						/>
					}
				/>
				<div className={'kootenai-type-SECTION'}>
					<h3>Miscellaneous</h3>
				</div>
				<FormField
					labelText={`Seller's contribution`}
					Component={
						<CurrencyField
							onChange={(event: any, input: any) => {
								store.setSellersContributions(input);
								props.setEstimatedTotalCosts();
								props.setEstimatedNetProceeds();
							}}
							value={props.sellersContributions.formatted}
						/>
					}
				/>
				<Grid>
					<Grid.Row columns={2}>
						<Grid.Column>
							<FormField
								labelText={'Other 1'}
								placeholder={'Label name'}
								onChange={(event: any, input: any) => {
									store.setOther1Label(input.value);
								}}
								value={store.other1Label}
							/>
						</Grid.Column>
						<Grid.Column>
							<FormField
								Component={
									<CurrencyField
										onChange={(event: any, input: any) => {
											store.setOther1(input);
											props.setEstimatedTotalCosts();
											props.setEstimatedNetProceeds();
										}}
										value={props.other1.formatted}
									/>
								}
							/>
						</Grid.Column>
					</Grid.Row>
				</Grid>
				<Grid>
					<Grid.Row columns={2}>
						<Grid.Column>
							<FormField
								labelText={'Other 2'}
								placeholder={'Label name'}
								onChange={(event: any, input: any) => {
									store.setOther2Label(input.value);
								}}
								value={props.other2Label}
							/>
						</Grid.Column>
						<Grid.Column>
							<FormField
								Component={
									<CurrencyField
										onChange={(even: any, input: any) => {
											store.setOther2(input);
											props.setEstimatedTotalCosts();
											props.setEstimatedNetProceeds();
										}}
										value={props.other2.formatted}
									/>
								}
							/>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Grid.Column>
		</Grid>
	);
};

export default withState(selectors)(SellerForm);
